import { fetchVendors, selectVendor, resetCurrentVendor, attachDocument } from '../../actions/vendors_actions';
import { connect } from 'react-redux';

import Vendors from '../../components/Vendors/vendors'

function mapStateToProps(state) {
  return {
    vendors: state.vendors.all,
    currentVendor: state.vendors.currentVendor,
    isLoading: state.vendors.isLoading,
    error: state.vendors.error,
    userPermissions: state.auth.userPermissions,
    selectedCompany: state.header.selectedCompany,
    isAttachingDocument: state.vendors.isAttachingDocument,
  };
}

export default connect(mapStateToProps, { fetchVendors, selectVendor, resetCurrentVendor, attachDocument })(Vendors);



// WEBPACK FOOTER //
// ./master/jsx/containers/Vendors/vendors.jsx